import { Component } from '../core/smpl-components.js'
import { Island } from '../core/island.js'
import { AhoyIsland } from '../islands/ahoy/index.jsx'

// The Component wrapper bridges the DOM/Twig world and the Preact island.
// ComponentsManager (see setup/components.js) instantiates this for every
// element matching `.js-ahoy-island`, then calls prepare() -> mount().
export default class extends Component {
	// Parse the JSON config blob Twig rendered into the element.
	getConfig() {
		const json = this.element.querySelector('script[data-ahoy-data]')
		if (!json) return {}
		try {
			return JSON.parse(json.textContent ?? '{}')
		} catch (error) {
			console.warn('Invalid ahoy data payload:', error)
			return {}
		}
	}

	prepare() {
		// Mount the Preact island into the [data-island-container] slot,
		// passing the parsed config through as props.
		this.island = new Island({
			element: this.element.querySelector('[data-island-container]'),
			component: AhoyIsland,
			props: { config: this.getConfig() },
		})
		this.island.mount()

		// island -> wrapper: react to the click, then talk back down with a command.
		this.island.on('ahoy', ({ count }) => {
			console.log('[ahoy] island emitted, count =', count)
			this.island.command('shout', { text: `Wrapper heard you ${count}×!` })
		})
	}

	unmount() {
		this.island?.unmount()
		this.island = null
	}
}
